!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t(require("create-emotion"), require("create-emotion-server"));else if ("function" == typeof define && define.amd) define(["create-emotion", "create-emotion-server"], t);else {
    var r = "object" == typeof exports ? t(require("create-emotion"), require("create-emotion-server")) : t(e["create-emotion"], e["create-emotion-server"]);

    for (var o in r) {
      ("object" == typeof exports ? exports : e)[o] = r[o];
    }
  }
}("undefined" != typeof self ? self : this, function (e, t) {
  return function (e) {
    var t = {};

    function r(o) {
      if (t[o]) return t[o].exports;
      var n = t[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(n.exports, n, n.exports, r), n.l = !0, n.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, o) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: o
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var o = Object.create(null);
      if (r.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var n in e) {
        r.d(o, n, function (t) {
          return e[t];
        }.bind(null, n));
      }
      return o;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 0);
  }([function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.renderStylesToNodeStream = t.renderStylesToString = t.extractCritical = t.cache = t.sheet = t.css = t.keyframes = t.injectGlobal = t.getRegisteredStyles = t.merge = t.cx = t.hydrate = t.flush = void 0;
    var o = u(r(1)),
        n = u(r(3));

    function u(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var a = o.default.flush,
        i = o.default.hydrate,
        f = o.default.cx,
        l = o.default.merge,
        d = o.default.getRegisteredStyles,
        c = o.default.injectGlobal,
        s = o.default.keyframes,
        y = o.default.css,
        p = o.default.sheet,
        m = o.default.cache;
    t.cache = m, t.sheet = p, t.css = y, t.keyframes = s, t.injectGlobal = c, t.getRegisteredStyles = d, t.merge = l, t.cx = f, t.hydrate = i, t.flush = a;
    var v = (0, n.default)(m),
        b = v.extractCritical,
        S = v.renderStylesToString,
        g = v.renderStylesToNodeStream;
    t.renderStylesToNodeStream = g, t.renderStylesToString = S, t.extractCritical = b;
    var x = o.default;
    t.default = x;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var o,
        n = (o = r(2)) && o.__esModule ? o : {
      default: o
    };

    var u = function () {
      var e = {
        key: "leafygreen-ui"
      };

      if ("undefined" != typeof window) {
        e.container = document.createElement("div");
        var t = document.head;
        t.insertBefore(e.container, t.firstChild);
      }

      return (0, n.default)(e);
    }();

    t.default = u;
  }, function (t, r) {
    t.exports = e;
  }, function (e, r) {
    e.exports = t;
  }]);
});